import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import { makeStyles } from '@mui/styles';
import { TABLET_BREAKPOINT } from '../../Helpers/constant';

const useStyles = makeStyles((theme) => ({
  rootAccordionSummary: {
    marginTop : '12px !important',
    borderBottom: `1px solid #E5E6EA !important`,
    '&> .MuiAccordionSummary-expandIconWrapper': {
      color: theme.palette.KenColors.neutral900,
    },
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      padding: '0 8px',
      minHeight: '40px',
      '& .MuiAccordionSummary-content': {
        margin: '8px 0',
      },
    },
  },
  label: {
    color: theme.palette.KenColors.neutral900,
    textAlign: 'left',
    fontWeight: '500',
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      'font-style': 'normal',
      'font-weight': '500',
      'line-height': '100%',
      color: theme.palette.KenColors.neutral900,
    },
  },
  listContainer: {
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      padding: '4px 8px 12px',
    },
  },
}));

export default function KenAccordion(props) {
  const { children, label } = props;
  const classes = useStyles();
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down(TABLET_BREAKPOINT));

  return (
    <Box margin={isMobileScreen ? '8px' : undefined}>
      <Accordion elevation={0}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header" classes={{ root: classes.rootAccordionSummary }}>
          <Box className={classes.label} sx={{ fontSize: '12px', fontWeight: 500 }}>
            {label}
          </Box>
        </AccordionSummary>
        <AccordionDetails className={classes.listContainer}>{children}</AccordionDetails>
      </Accordion>
    </Box>
  );
}
